import { defineStore } from 'pinia'
import { getAuth, getLog } from '~/utils/auth'

export const useRootStore = defineStore('root', {
  state: () => ({
    loading: [],
    errors: [],
    couponCode: '',
    couponDetails: {},
    couponError: {},
  }),

  actions: {
    addLoading(id) {
      if (!this.loading.includes(id)) {
        this.loading.push(id)
      }
    },

    removeLoading(id) {
      this.loading = this.loading.filter((item) => item !== id)
    },

    addError({ id, error }) {
      this.errors.push({ id, error })
    },

    removeError(id) {
      this.errors = this.errors.filter((error) => error.id !== id)
    },

    setCouponCode(couponCode) {
      this.couponCode = couponCode
      this.couponDetails = {}
      this.couponError = {}
    },

    removeCouponCode() {
      this.couponCode = ''
      this.couponDetails = {}
      this.couponError = {}
    },

    setCouponDetails(couponDetails) {
      this.couponCode = couponDetails?.code || ''
      this.couponDetails = { ...couponDetails }
      this.couponError = {}
    },

    setCouponError(couponError) {
      this.couponDetails = {}
      this.couponError = { ...couponError }
    },

    async silentLogOut({ source = '' }) {
      const $auth = getAuth()
      const $log = getLog()
      if (!$auth) {
        if ($log) {
          $log({
            name: 'no Auth available while silentLogout',
            properties: { source, pinia: true },
          })
        }
        return
      }

      await $auth.logout('local')
      if ($log) {
        $log({
          name: 'SilentLogOut',
          properties: { source, pinia: true },
        })
      }

      // Reset order state after logout - calling Vuex store action
      // TODO: update call to Pinia
      if (process.client && window.$nuxt?.$store) {
        await window.$nuxt.$store.dispatch('order/resetOrder')
      }
    },
  },
})
